import {
  RECORDING_BLOCK_SELECTOR,
  RECORDING_MASK_SELECTOR,
} from '@/analytics/constants'
import { PHOENIX_EVENT_CONTEXT } from '@/analytics/phoenixContext'
import { MARTECH_ENABLED_ENV, shouldSuppressMartech } from '@repo/martech-guard'
import mixpanel, { type Mixpanel } from 'mixpanel-browser'
import type { App, Plugin } from 'vue'
import { setMixpanelClient } from './analyticsClients'

export type MixpanelOptions = {
  token: string
}

export const mixpanelPlugin: Plugin = {
  install(_: App, { token }: MixpanelOptions): void {
    setMixpanelClient(undefined)

    if (!token) return

    if (shouldSuppressMartech({
      isLocalDevServer: import.meta.env.DEV,
      env: { [MARTECH_ENABLED_ENV]: import.meta.env.VITE_MARTECH_ENABLED },
    })) {
      return
    }

    try {
      // Session replay only — events flow through Segment + CIO via useAnalytics().
      // Replay metadata is attached to Segment events via mixpanelMiddleware in segment.ts.
      // https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript/javascript-replay#segment-analyticsjs
      mixpanel.init(token, {
        record_sessions_percent: 0,
        remote_settings_mode: 'fallback',
        record_mask_all_inputs: false,
        record_mask_all_text: false,
        record_heatmap_data: true,
        record_inline_images: true,
        record_mask_text_selector: [RECORDING_MASK_SELECTOR],
        record_block_selector: `${RECORDING_BLOCK_SELECTOR}, video`,
      })

      mixpanel.register(PHOENIX_EVENT_CONTEXT)

      setMixpanelClient(mixpanel)
    } catch (err) {
      console.error('Error loading Mixpanel: ', err)
      setMixpanelClient(undefined)
    }
  },
}

export type { Mixpanel }
